import type { CustomTooltipProps } from 'ag-grid-react';
import type { CSSProperties, FunctionComponent } from 'react';

// Mirror ZfTooltip's `.content` styling so the enforce-disabled remark tooltip matches the
// name/overflow tooltip, while wrapping the full remark text instead of truncating it.
const contentStyle: CSSProperties = {
    maxWidth: 'var(--zf-tooltip-max-width-default, 240px)',
    backgroundColor: 'var(--zf-tooltip-bg-color-default)',
    color: 'var(--zf-tooltip-fg-color-default)',
    borderRadius: 'var(--border-radius-lg)',
    padding: 'var(--padding-vertical-xxs) var(--padding-horizontal-xs)',
    textAlign: 'left',
    overflowWrap: 'break-word',
    hyphens: 'auto',
    fontSize: 'var(--type-label-medium-font-size)',
    lineHeight: 'var(--type-label-medium-line-height)',
    fontFamily: 'var(--type-label-medium-regular-font-family)',
    fontWeight: 'var(--type-label-medium-regular-font-weight)',
    letterSpacing: 'var(--type-label-medium-regular-letter-spacing)',
    boxShadow:
        'var(--drop-shadow-elevation-small-secondary-x-value) var(--drop-shadow-elevation-small-secondary-y-value) var(--drop-shadow-elevation-small-secondary-blur) var(--drop-shadow-elevation-small-secondary), var(--drop-shadow-elevation-small-primary-x-value) var(--drop-shadow-elevation-small-primary-y-value) var(--drop-shadow-elevation-small-primary-blur) var(--drop-shadow-elevation-small-primary)',
};

export const RemarkTooltip: FunctionComponent<CustomTooltipProps> = ({ value }) => {
    if (!value) return null;

    return <div style={contentStyle}>{value}</div>;
};
